export default async () => {
    /**
     * Modules
     */
    const context = require.context(
        './modules',
        true,
        /[A-Za-z]+\/[A-Za-z]+Windows\.js$/ // Ej: Care/CareWindows.js, Tracker/TrackerWindows.js, etc.
    );

    // Importa todos los arrays de componentes de cada módulo dinámico
    const moduleComponentsArrays = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const key of context.keys()) {
        // eslint-disable-next-line no-await-in-loop
        const mod = await context(key);
        if (mod && mod.default) {
            moduleComponentsArrays.push(mod.default);
        }
    }

    // Componentes propios del core Darmin, importados manual
    const darminComponents = [
        {
            title: 'Home',
            load: () => import('@/components/home/Home.vue'),
        },
        {
            title: 'Test',
            load: () => import('@/components/test/Test.vue'),
        },
        {
            title: 'MenuEditor',
            load: () => import('@/modules/Darmin/MenuEditor/MenuEditor.vue'),
        },
        {
            title: 'MenuItemForm',
            load: () => import('@/modules/Darmin/MenuEditor/MenuItemForm.vue'),
        },
        {
            title: 'List',
            load: () => import('@/components/list/List.vue'),
        },
        {
            title: 'UserProfileForm',
            load: () => import('@/modules/Darmin/UserProfile/UserProfileForm.vue'),
        },
        {
            title: 'PermissionCategoryForm',
            load: () =>
                // eslint-disable-next-line implicit-arrow-linebreak
                import('@/modules/Darmin/PermissionCategory/PermissionCategoryForm.vue'),
        },
        {
            title: 'PermissionForm',
            load: () => import('@/modules/Darmin/Permission/PermissionForm.vue'),
        },
        {
            title: 'UserForm',
            load: () => import('@/modules/Darmin/Users/UserForm.vue'),
        },
        {
            title: 'ParametersForm',
            load: () => import('@/modules/Darmin/Parameters/ParametersForm.vue'),
        },
        {
            title: 'TopicsForm',
            load: () => import('@/modules/Darmin/Notifications/TopicsForm.vue'),
        },
        {
            title: 'SubscriptionsForm',
            load: () => import('@/modules/Darmin/Notifications/SubscriptionsForm.vue'),
        },
        {
            title: 'NotificationsDetail',
            load: () => import('@/modules/Darmin/Notifications/NotificationsDetail.vue'),
        },
    ];

    return {
        components: [
            ...darminComponents,
            ...moduleComponentsArrays.flat(), // aplanado por si cada archivo exporta un array
        ],
        getComponent(title) {
            return this.components.find((obj) => obj.title === title);
        },
        getSelect() {
            return this.components.map((c) => ({ id: c.title, label: c.title }));
        },
    };
};
